import { Block } from 'components/Block'
import {
  SFutureMessageLPHow,
  SFutureMessageLPHowImageWrapper,
  SFutureMessageLPHowTextWrapper,
} from './FutureMessageLPHow.styled'
import { ContentfulImage } from 'components/Image'
import { TranslatableLink } from 'components/TranslatableLink'
import { Text, Title, Title_h3_default } from 'components/Typography'
import { Trans, useTranslation } from 'next-i18next'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { numberRange } from 'utils/general'
import { useWindowSize } from 'utils/hooks'

export const FutureMessageLPHow = (props: { className?: string }) => {
  const { t } = useTranslation('future_message')
  const images = useContentfulImages()
  const { isDesktop } = useWindowSize()

  return (
    <Block className={props.className} css={{ '--width': '1178px', overflow: 'hidden' }}>
      <SFutureMessageLPHow>
        {!isDesktop && (
          <Title variant={Title_h3_default} as="h3" css={{ marginBottom: '0.5rem' }}>
            {t('future_message.how_to_create_section.mobile_title')}
          </Title>
        )}

        <SFutureMessageLPHowTextWrapper>
          {isDesktop && (
            <Title variant={Title_h3_default} as="h3" css={{ marginBottom: '1.5rem' }}>
              {t('future_message.how_to_create_section.desktop_title')}
            </Title>
          )}

          <Text as="div">
            <Trans
              t={t}
              i18nKey="future_message.how_to_create_section.description"
              components={[<TranslatableLink variant="basic" key="0" href="/memories" />]}
            />
            <ul css={{ marginTop: '0' }}>
              {numberRange(4).map((i) => (
                <li key={i}>{t(`future_message.how_to_create_section.list_item_${i}`)}</li>
              ))}
            </ul>
            {t('future_message.how_to_create_section.description_2')}
            <br />
            <br />
            {t('future_message.how_to_create_section.numbered_list_description')}
            <ol css={{ marginTop: '0' }}>
              {numberRange(5).map((i) => (
                <li key={i}>{t(`future_message.how_to_create_section.numbered_list_item_${i}`)}</li>
              ))}
            </ol>
          </Text>
        </SFutureMessageLPHowTextWrapper>

        <SFutureMessageLPHowImageWrapper>
          <ContentfulImage {...images.future_message_how_to_create} />
        </SFutureMessageLPHowImageWrapper>
      </SFutureMessageLPHow>
    </Block>
  )
}
